var modules_c9d990f9 = {"icon":"_10oyogz","is-arrow-turned":"_1g6nb03"};
import "../../../assets/DZcRhUF4.css";

export { modules_c9d990f9 as default };
//# sourceMappingURL=IconElement.module.less.js.map
